import React from 'react';
import { Section } from '../components/Section';
import { StartHere } from '../components/StartHere';
import { asset } from '../data/redesignAssets';
import { TEAM } from '../data/team';
export function About() {
  return <>
      <Section n="01" label="About" noTop contentClassName="page-hero" data-id="element-341" data-mp="29l6pp8bd7jge">
        <h1 className="h1" style={{
        maxWidth: 1000
      }} data-id="element-342" data-mp="2ehx65wr30h2c">
          The missing half of the AI stack
        </h1>
        <blockquote className="about-quote" data-id="element-343" data-mp="329cbzzi2hgic">
          “The moment AI works for your company, there are rules that have to be there by law, by policy, or by hard-won
          experience. Synthia makes sure they are.”
        </blockquote>
        <p className="lede" style={{
        maxWidth: 960
      }} data-id="element-344" data-mp="2sc7ljnh6uyvq">
          Your AI stack is good at knowledge. It stores every document, file, and database you give it and recalls any of them on demand.
          The rules are the missing half, and the stack has no place to keep them. They ride on someone remembering to type them, or on
          retrieval happening to surface them, and that holds until a prompt is rushed or an agent runs with nobody watching.{' '}
          <strong data-id="element-345" data-mp="1pjqjkbo2mhx8">Synthia is the instruction layer for the enterprise.</strong> Pre-flight, before a single token is generated, it seats
          your obligations alongside the prompt and signs a receipt proving they were there. An answer without that receipt is one you
          can&rsquo;t defend.
        </p>
      </Section>

      <section className="bleed sec-dk does" data-id="element-346" data-mp="2deten1dgxhm5">
        <div className="sec" style={{
        borderTop: 0
      }} data-id="element-347" data-mp="28i2yyf5kso19">
          <div className="sec-m" data-id="element-348" data-mp="28fgr0eerw6ii">
            <div className="sec-l" data-id="element-349" data-mp="2m8pszu0e5pr0">Why</div>
          </div>
          <div className="why-c" data-id="element-350" data-mp="2m86g4rpllrju">
            <p className="why" data-id="element-351" data-mp="2i7mi7lx7ajwn">
              The fifth time we saw the same correction, we stopped calling it a correction. It was a missing obligation, and the model
              kept committing us without it.
              <br data-id="element-352" data-mp="2r8kk9yo2whcl" />
              <span style={{
              color: 'var(--mint)'
            }} data-id="element-353" data-mp="2r9dl6j0cwcmt">So we automated the obligations.</span>
            </p>
          </div>
        </div>
      </section>

      <Section n="03" label="The people" data-id="element-354" data-mp="1sw8099fjhot5">
        <h2 className="h2" data-id="element-355" data-mp="1sx9n0b5x3zqp">Humans in the loop.</h2>
        <div className="team" data-id="element-356" data-mp="1stvndaon24my">
          {TEAM.map(p => <div className="person" key={p.name} data-id="element-357" data-mp="1xtrpt5hoto0e">
              <img src={asset(p.photo)} alt={p.name} loading="lazy" data-id="element-358" data-mp="22lrkojiwhqq4" />
              <div className="id" data-id="element-359" data-mp="22o4bznajtdfu">
                <div className="nm" data-id="element-360" data-mp="27lnn4eby9a3k">{p.name}</div>
                <div className="rl" data-id="element-361" data-mp="27kuq452slyym">{p.role}</div>
              </div>
              <div className="bio" data-id="element-362" data-mp="2cj5zyft389gu">{p.bio}</div>
            </div>)}
        </div>
      </Section>

      <StartHere n="04" data-id="element-363" data-mp="2gn3zgrmbrmaf" />
    </>;
}